'use strict';

import 'Components/01-components/wsuperson.css';
import '@wrightstate/web_embeds/wsu_embeds.css';
import '@wrightstate/web_embeds/components/campuslabs/campuslabs.css';

const settings = drupalSettings.wsu_embeds;

const embeds = [
  {
    elements: document.querySelectorAll('.wsu-embed-giving'),
    import: ['web_embeds', 'giving'],
    render: (Component, element) => Component(element, settings.givingAppBase, settings.givingApiBase)
  },
  {
    elements: document.querySelectorAll('.wsu-embed-news'),
    import: ['web_embeds', 'news'],
    render: (Component, element) => Component(element)
  },
  {
    elements: document.querySelectorAll('.wsu-embed-people'),
    import: ['web_embeds', 'people'],
    render: (Component, element) => Component(element, settings.peopleApi)
  },
  {
    elements: document.querySelectorAll('.wsu-embed-organizations'),
    import: ['web_embeds', 'campuslabs'],
    render: (Component, element) => Component(element)
  }
];

embeds.forEach((embed) => {
  if (!embed.elements.length) { return; }

  let dynamicImport;
  switch (embed.import[0]) {
    case 'web_embeds':
      dynamicImport = import(
        /* webpackChunkName: "wsu_embeds_components" */
        /* webpackMode: "lazy-once" */
        `@wrightstate/web_embeds/components/${embed.import[1]}/index`
      );
      break;
    default:
      return;
  }
  dynamicImport.then(module => {
    embed.elements.forEach(element => embed.render(module.default, element));
  });
});
